export var SUCCESS_MSG = {
    message: 'Changes saved',
};
export var USER_REMOVED_SUCCESS_MSG = {
    message: 'User Removed',
};
export var USERS_REMOVED_SUCCESS_MSG = {
    message: 'Users Removed',
};
export var USER_ADDED_SUCCESS_MSG = {
    message: 'User Added',
};
export var USER_ADDED_SUCCESS_MSG_WITH_EXPIRATION_DATE = {
    message: function (expirationDate) {
        return "User invite sent. This invite expires on ".concat(expirationDate);
    },
};
export var FILE_EXPORTED_SUCCESS_MSG = {
    message: 'User data successfully exported. Please check your downloads folder for the file.',
};
export var FILE_PRINTED_SUCCESS_MSG = {
    message: 'User data is ready to print. Please check your downloads folder for the file.',
};
export var USER_UPDATED_SUCCESS_MSG = {
    message: 'Changes Saved',
};
export var USER_RESEND_INVITE_SUCCESS_MSG = {
    message: function (expirationDate) {
        return "User invite sent. This invite expires on ".concat(expirationDate);
    },
};
export var MULTI_RESEND_INVITE_SUCCESS_MSG = {
    message: 'Invite(s) Resent',
};
export var MULTI_RESEND_INVITE_SUCCESS_MSG_WITH_EXPIRATION = {
    message: function (userInviteExpirationDate) {
        return "User invite(s) sent. These invites expire on ".concat(userInviteExpirationDate);
    },
};
export var getBulkAddSuccessMessage = function (usersLength) { return ({
    message: "You've successfully added ".concat(usersLength, " users to your account. It may take a few minutes for your account to update. New users will receive an invite email shortly with login instructions."),
}); };
export var getBulkAddSuccessMessageWithExpirationDate = function (usersLength, userInviteExpirationDate) { return ({
    message: "You've successfully added ".concat(usersLength, " users to your account. It may take a few minutes for your account to update. New users will receive an invite email shortly with login instructions. These invites expires on ").concat(userInviteExpirationDate),
}); };
